import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Card, Table, Button, Container } from 'react-bootstrap';
import Moment from 'react-moment';
import { observer, inject } from 'mobx-react';
import { Client } from '../../models';
import { ClientEntryStore } from '../../stores/client-entry-store';
import { BloodworkEntryStore } from '../../stores/bloodwork-entry-store';
import { UserProfile } from '../../models/UserProfile';
import { GenericModal } from '../common/generic-modal';

type Props = {
  clients: Client[];
  currentUserProfile: UserProfile;
  clientEntryStore: ClientEntryStore;
  bloodworkEntryStore: BloodworkEntryStore;
  history?: any;
};

type State = {
  showUpgradeModal: boolean;
};

@inject('clientEntryStore', 'bloodworkEntryStore')
@observer
export class ClientDisplay extends React.Component<Props, State> {
  state: State = {
    showUpgradeModal: false
  };

  addTestResult(client: Client): void {
    const { clientEntryStore, bloodworkEntryStore, history } = this.props;
    clientEntryStore.setCurrentClient(client);
    bloodworkEntryStore.resetCurrentBloodwork();
    bloodworkEntryStore.setHideEnterTestResults(false);
    history.push(`/bloodwork/edit/${client.id}`);
  }

  deleteClient(client: Client): void {
    const deleteClient = window.confirm('Deleting a client will also delete all the test results for that client.\n\n' + 
      'Are you sure you want to delete this client and their test results?');
    
    if (deleteClient) {
      const { clientEntryStore, bloodworkEntryStore } = this.props;
      bloodworkEntryStore.loadClientBloodworks(client.id).then(() => {
        return bloodworkEntryStore.deleteClientBloodworks(client.id);        
      }).then(() => {
        if (bloodworkEntryStore.clientBloodworks.length === 0) {
          return Promise.resolve();
        } else {  
          return Promise.reject('Not all of the client bloodworks were deleted. Not deleting client.');
        }
      }).then(() => {
        return clientEntryStore.deleteClient(client);
      }).then(() => {
        return clientEntryStore.resetCurrentClient();
      }).catch((error) => {
        console.error(error);
        alert('There was an error trying to delete the client and their test results.');
      });
    }
  }

  editClient(client: Client) {
    const { currentUserProfile, clientEntryStore, history } = this.props;
    if (currentUserProfile.editClientAllowed) {
      if (history && history.location && history.location.pathname !== '/client/edit/manage') {
        history.push('/client/edit/manage');
      }
      clientEntryStore.setCurrentClient(client);
      clientEntryStore.setExpandAddClient(true);
      // This is a hack to expand add/edit client panel on first click of edit
      setTimeout(()=>{
        clientEntryStore.setExpandAddClient(true);
        this.scrollTop();
      }, 1000);
    } else {
      this.setState({
        showUpgradeModal: true
      });
    }
  }

  scrollTop() {
    document.body.scrollTop = 0; 
    document.documentElement.scrollTop = 0;
  }

  render() {
    const { clients } = this.props;
    const { showUpgradeModal } = this.state;
    console.log(clients);
    
    if (!clients || !clients.length) {
      return null;
    }

    return (
      <>
        <Container fluid>
          <Card>
            <Card.Header>Clients</Card.Header>
            <Card.Body>
              <div>
                { (clients.length > 0) ?
                  <Table striped bordered hover className="labsmartz-table">
                    <thead>
                      <tr>
                        <th>Actions</th>
                        <th>Last Name</th>
                        <th>First Name</th>
                        <th>Sex</th>
                        <th>Date of Birth</th> 
                        <th>Age</th>
                        <th>Ethnicity</th>
                        <th>Menopause/Pregnant</th>
                        <th>Trimester</th>
                        <th>Elevation</th>
                        <th>Cigarettes Smoked</th>
                        <th>Standard Drinks</th>      
                        <th>Date Created</th>                 
                      </tr>
                    </thead>
                    <tbody>
                      { 
                        clients.map((client: Client, index: number) => {
                          console.log(client);
                          return (
                            <tr key={index}>
                              <td style={{ width: '150px' }}>
                                <Button 
                                  type="button"
                                  title="Add Test Results"
                                  onClick={() => { this.addTestResult(client); }}
                                >
                                  <FontAwesomeIcon icon="tint" />
                                </Button>
                                &nbsp;&nbsp;
                                <Button 
                                  type="button"
                                  title="Edit Client"
                                  onClick={() => { this.editClient(client); }}
                                >
                                  <FontAwesomeIcon icon="user-edit" />
                                </Button>
                                &nbsp;&nbsp;
                                <Button
                                  title="Delete Client"
                                  onClick={() => { this.deleteClient(client); }}
                                ><FontAwesomeIcon icon="trash-alt" />
                                </Button>                            
                              </td> 
                              <td>{client.lastName}</td>                          
                              <td>{client.firstName}</td>
                              <td>{client.displayGender}</td>
                              <td><Moment format="MM/DD/YYYY">{client.dateOfBirth}</Moment></td>
                              <td>{client.displayAge}</td>
                              <td>{client.displayEthnicity}</td>
                              <td>{client.displayMenopause}</td>
                              <td>{client.displayTrimester}</td>
                              <td>{client.displayElevation}</td>
                              <td>{client.displayCigaretteesSmoked}</td>
                              <td>{client.displayStandardDrinks}</td>
                              <td><Moment format="MM/DD/YYYY">{client.createDate}</Moment></td>
                            </tr>
                          );
                        })
                      }
                    </tbody>
                  </Table> : null
                }
              </div>
            </Card.Body>
          </Card>       
        </Container>
        <GenericModal 
          show={showUpgradeModal} 
          title="Edit Client Feature Not Available"
          text="Edit Client feature is not available with a free account."
          link="https://labsmarts.com/pricing"
          linkText="Click here to upgrade."
          onHide={() => { this.setState( { showUpgradeModal: false }); }}
        />
      </>
    );
  }
}
